import React from "react";
import "../ProductConfig.scss";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Modal } from "@mui/material";
import UGTable from "../../../../../Supporting files/UGTable/UGTable";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
// import AddFeatures from "../../../../../Components/Broker/ProductConfigurator/AddFeatures/AddFeatures";
import ModifyFeature from "../../../../../Components/Broker/ProductConfigurator/ModifyFeature/ModifyFeature";
// import AddCategory from "../../../../../Components/Broker/ProductConfigurator/Categories/AddCategory";
import RemovePopup from "../../../../../Components/Common/CarForm/RemovePopup/RemovePopup";
import { useNavigate } from "react-router-dom";
import SearchBox from "../../../../../Components/Broker/SearchBarAnimation/SearchBox";
function Insurers() {
  const [productTabsStatus, setProductTabsStatus] = React.useState("Insurers");
  const [addNewInsurer, setAddNewInsurer] = React.useState(false);
  const [hideDataStatus, setHideDataStatus] = React.useState(false);
  const [removeCategory, setRemoveCategory] = React.useState(false);
  //Features Variables
  const [addNewFeatures, setAddNewFeatures] = React.useState(false);
  const [modifyFeature, setModifyFeatures] = React.useState(false);
  const [addNewCategory, setAddNewCategory] = React.useState(false);
  const navigate = useNavigate();

  //Category Data
  const [columns, setColumns] = React.useState([
    {
      field: "sr_no",
      headerName: "Sr. No.",
      width: 80,
      check_status: true,
    },
    {
      field: "category_name",
      headerName: "Category Name",
      minWidth: 260,
      check_status: true,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 3,
      minWidth: 150,
      check_status: true,
    },
    {
      field: "action_btns",
      headerName: "Action",
      width: 150,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            className="blueBtn edit ml-0"
            underline="none"
            onClick={() => {
              setAddNewCategory(true);
            }}
          >
            Edit
          </Link>
        );
      },
    },
  ]);
  const rows = [
    {
      id: 0,
      sr_no: "1",
      category_name: "Medical Cover",
      description: "Lorem ipsum dolor sit amet",
      action_btns: "Edit",
    },
    {
      id: 1,
      sr_no: "2",
      category_name: "Ayus Treatment",
      description: "Lorem ipsum dolor sit amet",
      action_btns: "Edit",
    },
  ];
  //Features Data
  const [lifeColumns, setLifeColumns] = React.useState([
    {
      field: "sr_no",
      headerName: "Sr. No.",
      width: 80,
      check_status: true,
    },
    {
      field: "insurer_logo",
      headerName: "Logo",
      width: 250,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <img
            src={row.insurer_logo}
            style={{
              height: "40px",
              background: "#FFFFFF",
              width: "80px",
              borderRadius: "5px",
              paddingLeft: "5px",
              paddingRight: "5px",
            }}
          />
        );
      },
    },
    {
      field: "insurer_name",
      headerName: "Name",
      width: 600,
      check_status: true,
    },
    {
      field: "network_hospital",
      headerName: "Network Hospitals",
      width: 200,
      check_status: true,
    },
    {
      field: "website_url",
      headerName: "Website Url",
      flex: 3,
      minWidth: 300,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link href={row.website_url} target="_blank" underline="none">
            {row.website_url}
          </Link>
        );
      },
    },
    {
      field: "action_btns",
      headerName: "Action",
      width: 150,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            className="blueBtn edit ml-0"
            underline="none"
            onClick={() => {
              setModifyFeatures(true);
            }}
          >
            Edit
          </Link>
        );
      },
    },
  ]);
  const liferows = [
    {
      id: 0,
      sr_no: "1",
      insurer_logo: "./images/insurerlogo/aditya_birla_capital.svg",
      insurer_name: "Aditya Birla Sun Life Insurance Company Limited",
      network_hospital: "142",
      website_url: "www.insurerwebsite.com",
      action_btns: "Edit",
    },
    {
      id: 1,
      sr_no: "2",
      insurer_logo:
        "./images/insurerlogo/Religare-Health-Insurance-Company-Limited.svg",
      insurer_name: "Religare Health Insurance Company Limited",
      network_hospital: "192",
      website_url: "www.insurerwebsite.com",
      action_btns: "Edit",
    },
    {
      id: 2,
      sr_no: "3",
      insurer_logo: "./images/insurerlogo/Raheja-QBE.svg",
      insurer_name: "Raheja QBE General Insurance Co. Ltd.",
      network_hospital: "196",
      website_url: "www.insurerwebsite.com",
      action_btns: "Edit",
    },
  ];
  const [generalColumns, setGeneralColumns] = React.useState([
    {
      field: "sr_no",
      headerName: "Sr. No.",
      width: 80,
      check_status: true,
    },
    {
      field: "insurer_logo",
      headerName: "Logo",
      width: 250,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <img
            src={row.insurer_logo}
            style={{
              height: "40px",
              background: "#FFFFFF",
              width: "80px",
              borderRadius: "5px",
              paddingLeft: "5px",
              paddingRight: "5px",
            }}
          />
        );
      },
    },
    {
      field: "insurer_name",
      headerName: "Name",
      width: 600,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <button
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              background: "transparent",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate("/InsurerDetails");
            }}
          >
            {row.insurer_name}
          </button>
        );
      },
    },
    {
      field: "network_hospital",
      headerName: "Network Hospitals",
      width: 200,
      check_status: true,
    },
    {
      field: "website_url",
      headerName: "Website Url",
      flex: 3,
      minWidth: 300,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link href={row.website_url} target="_blank" underline="none">
            {row.website_url}
          </Link>
        );
      },
    },
    {
      field: "action_btns",
      headerName: "Action",
      width: 150,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            className="blueBtn edit ml-0"
            underline="none"
            onClick={() => {
              setModifyFeatures(true);
            }}
          >
            Edit
          </Link>
        );
      },
    },
  ]);
  const generalrows = [
    {
      id: 0,
      sr_no: "1",
      insurer_logo: "./images/insurerlogo/digit.svg",
      insurer_name: "Go Digit General Insurance Limited",
      network_hospital: "142",
      website_url: "www.insurerwebsite.com",
      action_btns: "Edit",
    },
    {
      id: 1,
      sr_no: "2",
      insurer_logo: "./images/insurerlogo/sbi_general_insurance.svg",
      insurer_name: "SBI General Insurance Company Limited",
      network_hospital: "192",
      website_url: "www.insurerwebsite.com",
      action_btns: "Edit",
    },
    {
      id: 2,
      sr_no: "3",
      insurer_logo: "./images/insurerlogo/Raheja-QBE.svg",
      insurer_name: "Raheja QBE General Insurance Co. Ltd.",
      network_hospital: "196",
      website_url: "www.insurerwebsite.com",
      action_btns: "Edit",
    },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);

    if (attrName == setAddNewFeatures) {
      setHideDataStatus(value);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid xs={12}>
        <h3 className="mb-0">Insurers</h3>
      </Grid>
      <>
        <Grid xs={7} style={{ display: "flex", alignItems: "center" }}>
          <div className="productTabs mr-3">
            <Button
              className={
                productTabsStatus == "Insurers"
                  ? "defaultTab active"
                  : "defaultTab"
              }
              onClick={() => {
                updateMasterState(setProductTabsStatus, "Insurers");
                setProductTabsStatus("Insurers");
              }}
            >
              General Insurance
            </Button>
            <Button
              className={
                productTabsStatus == "life" ? "defaultTab active" : "defaultTab"
              }
              onClick={() => {
                updateMasterState(setProductTabsStatus, "life");
              }}
            >
              Life Insurance
            </Button>
          </div>
          <SearchBox />
        </Grid>
        <Grid xs={5} className="text-right">
          {productTabsStatus == "Insurers" ? (
            <>
              <Link
                className="redBtn delete"
                underline="none"
                onClick={() => {
                  setRemoveCategory(true);
                }}
              >
                Remove
              </Link>
              <Link
                className="greenBtn addfile"
                underline="none"
                onClick={() => {
                  navigate("/AddNewInsurer");
                }}
              >
                Add New
              </Link>
            </>
          ) : null}
          {productTabsStatus == "life" ? (
            <>
              <Link
                className="redBtn delete"
                underline="none"
                onClick={() => {
                  setRemoveCategory(true);
                }}
              >
                Remove
              </Link>
              <Link
                className="greenBtn addfile"
                underline="none"
                onClick={() => {
                  updateMasterState(setAddNewFeatures, true);
                }}
              >
                Add New
              </Link>
            </>
          ) : null}
        </Grid>
        <Grid xs={12}>
          {productTabsStatus == "life" ? (
            <div style={{ height: 400, width: "100%" }}>
              <UGTable
                header_data={lifeColumns}
                data={liferows}
                value_update={updateMasterState}
                attrName={"UGTable"}
              />
            </div>
          ) : null}
          {productTabsStatus == "Insurers" ? (
            <div style={{ height: 400, width: "100%" }}>
              <UGTable
                header_data={generalColumns}
                data={generalrows}
                value_update={updateMasterState}
                attrName={"UGTable"}
              />
            </div>
          ) : null}
        </Grid>
      </>

      <RemovePopup
        open_status={removeCategory}
        attrName={setRemoveCategory}
        value_update={updateMasterState}
      />
      <ModifyFeature
        attrName={setModifyFeatures}
        value_update={updateMasterState}
        open_status={modifyFeature}
      />
    </Grid>
  );
}

export default Insurers;
